import { Model } from 'dva'

const Applications: Model = {
  namespace: 'applications',
  state: {
    onBoardingStatus: false,
    onBoardingData: null,
  },
  reducers: {
    updateState(state, action) {
      const { payload } = action

      return {
        ...state,
        ...payload,
      }
    },
  },
}

export default Applications
